var _a;
import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import { coinbaseWallet, metaMaskWallet, phantomWallet, rabbyWallet, rainbowWallet, walletConnectWallet, } from '@rainbow-me/rainbowkit/wallets';
import { arbitrum, avalanche, base, bsc, mainnet, optimism, polygon } from 'wagmi/chains';
import { createConfig, http } from 'wagmi';
import { ChainId, PUBLIC_RPCS } from '@shared/utils/config/networks';
var projectId = 'a9af562c397c9da0117e339c27a8a789';
var connectors = connectorsForWallets([
    {
        groupName: 'Wallets',
        wallets: [
            rabbyWallet,
            metaMaskWallet,
            coinbaseWallet,
            phantomWallet,
            rainbowWallet,
            walletConnectWallet,
        ],
    },
], {
    appName: 'Genius Terminal',
    projectId: projectId,
});
export var wagmiChains = [mainnet, base, optimism, arbitrum, avalanche, bsc, polygon];
export var wagmiConfig = createConfig({
    ssr: true,
    connectors: connectors,
    chains: wagmiChains,
    transports: (_a = {},
        _a[mainnet.id] = http(PUBLIC_RPCS[ChainId.ETHEREUM]),
        _a[base.id] = http(PUBLIC_RPCS[ChainId.BASE]),
        _a[optimism.id] = http(PUBLIC_RPCS[ChainId.OPTIMISM]),
        _a[arbitrum.id] = http(PUBLIC_RPCS[ChainId.ARBITRUM]),
        _a[avalanche.id] = http(PUBLIC_RPCS[ChainId.AVALANCHE]),
        _a[bsc.id] = http(PUBLIC_RPCS[ChainId.BSC]),
        _a[polygon.id] = http(PUBLIC_RPCS[ChainId.POLYGON]),
        _a),
});
